import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fontSize", "color"];
import { Body } from './Body';
import { jsx as _jsx } from "react/jsx-runtime";
export const Label = _ref => {
  let {
      children,
      fontSize = 'sm',
      color = 'light'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Body, Object.assign({}, rest, {
    as: "label",
    color: color,
    display: "block",
    fontSize: fontSize,
    children: children
  }));
};